import React, { useEffect, useState } from "react";
import { getBizTimeSummary } from "../../../mypage/store/component/function/store";
import { MenuBoardDetails } from "../styled/setting";
import { useParams } from "react-router";
import axios from "axios";

const Details = ({ company, visibleMode = "" }) => {
  const { cmpnyNo } = useParams();
  const [companyData, setCompanyData] = useState(null);

  useEffect(() => {
    if (!company) return;
    getCompany();
  }, [company]);

  const decryptId = async (id) => {
    const url = "/etc/decrypt-6char";
    const body = { code: id };
    const res = await axios.post(url, body);
    return res.data.plain;
  };

  const getCompany = async () => {
    const decryptedId = await decryptId(cmpnyNo);
    if (!decryptedId) throw new Error("회사번호 없음");

    try {
      const url = "/api/cmpnyNo";
      const body = { cmpnyNo: decryptedId };
      const res = await axios.post(url, body);

      if (res.status === 200) {
        setCompanyData(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const renderData = [
    {
      title: company?.cmpnyNm,
      type: "fields",
      visible: visibleMode !== "info" && visibleMode !== "time",
      items: [
        {
          visible: !!company?.addr,
          label: "주소",
          value: `${company?.addr} ${company?.addrDetail}`,
        },
        {
          visible: !!companyData?.bizrno,
          label: "사업자등록번호",
          value: companyData?.bizrno,
        },
        {
          visible: !!companyData?.cmpnyNm,
          label: "상호명",
          value: companyData?.cmpnyNm,
        },
      ],
    },
    {
      title: "영업시간",
      type: "textList",
      visible: visibleMode !== "info",
      items: getBizTimeSummary(company?.businessHours),
    },
    {
      title: "공지사항",
      type: "text",
      content: company?.notice,
      visible: visibleMode !== "time",
    },
    {
      title: "원산지 정보",
      type: "text",
      content: company?.originInfo,
      visible: visibleMode !== "time",
    },
  ];

  return (
    <MenuBoardDetails>
      {renderData
        .filter((item) => item.visible)
        .map((section, i) => (
          <div key={i} className="section">
            <h3>{section.title}</h3>
            {section.type === "fields" &&
              section.items
                .filter((item) => item.visible)
                .map((item, idx) => (
                  <p key={idx}>
                    <span>{item.label}:</span> {item.value}
                  </p>
                ))}
            {section.type === "textList" &&
              section.items.map((item, idx) => <p key={`${item.key}-${idx}`}>{item}</p>)}
            {section.type === "text" && <p>{section.content}</p>}
          </div>
        ))}
    </MenuBoardDetails>
  );
};

export default Details;
